import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IDownloadInspecaoMaquinaEquipArquivoUseCase } from "../../../presentation/useCases/read/download_inspecao_maquina_equip_arquivo_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * DownloadInspecaoMaquinaEquipArquivoUseCase
 */

export class DownloadInspecaoMaquinaEquipArquivoUseCase implements IDownloadInspecaoMaquinaEquipArquivoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async downloadInspecaoMaquinaEquipArquivo(
    idControleCentroCusto: number,
    idInspecaoMaquinaEquip: number,
    fileIndex: number,
  ): Promise<void> {
    const response = await this.repository.downloadInspecaoMaquinaEquipArquivo(
      idControleCentroCusto,
      idInspecaoMaquinaEquip,
      fileIndex,
    );

    if (response !== null) {
      await downloadBase64File(response.arquivoNome, response.arquivoData);
    }
  }
}
